import * as React from 'react';
import { Button } from 'react-bootstrap';
import { OrganType } from '@nkr/enums/index';

interface IProps {
    isKidney: boolean;
    onOpenLink: (link: string) => void;
}

const PolicyFooter = ({ isKidney, onOpenLink }: IProps) => (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
        <span className='text-muted' style={{ fontSize: 12, marginRight: 4 }}>Donor Shield policies:</span>
        {isKidney && (
            <Button style={{ marginRight: 0 }} bsStyle='danger' bsSize='sm' onClick={() => onOpenLink('https://www.donorshield.com/policy')}>
                Kidney
            </Button>
        )}
        <Button bsStyle='warning' bsSize='sm' onClick={() => onOpenLink('https://www.donorshield.com/liverpolicy')}>
            Liver
        </Button>
    </div>
);

export default PolicyFooter;
